import React, { Component } from "react";
import CSSModules from "react-css-modules";
import css from "./styles.scss";

@CSSModules(css)
class LayoutContent extends Component {
  render() {
    return (
      <div
        styleName="withoutGrid"
        style={{
          paddingTop: "45px"
        }}
      >
        {this.props.children}
      </div>
    );
  }
}

export default LayoutContent;
